import {Module, NextModule} from '@backstage-components/base';
import React from 'react';
import {
  PublicAccessCodeComponent,
  PublicAccessCodeComponentDefinition,
} from './PublicAccessCodeComponent';
import {ComponentDefinition} from './PublicAccessCodeDefinition';

type Kind = PublicAccessCodeComponentDefinition['component'];

type Props = PublicAccessCodeComponentDefinition['props'];

export const PublicAccessCodeModule: Module<Kind, Props> = {
  isContent(value): value is PublicAccessCodeComponentDefinition {
    return (
      value.component === ComponentDefinition.reactName &&
      value.cid === ComponentDefinition.id
    );
  },
  isLayout(value): value is PublicAccessCodeComponentDefinition {
    return false;
  },
  tryRender(definition) {
    if (PublicAccessCodeModule.isContent(definition)) {
      return React.createElement(PublicAccessCodeComponent, definition);
    } else {
      return NextModule;
    }
  },
};
